import { filter, MonoTypeOperatorFunction } from 'rxjs';
import { IMessage } from '../data/message';

/**
 * @param key Key of the message to match
 *
 * @returns
 * Operator that takes a source that emits `IMessage`s
 * and that only emits, if the emitted message has a
 * matching key.
 */
export function filterByKey<T extends IMessage>(
  key: string,
): MonoTypeOperatorFunction<T> {
  return filter((m) => m.key === key);
}
